import createReducer from '../../util/createReducer';

export const SEND_PAY = 'SEND_PAY';

export const DEFAULT_SIZE = 10

export const HANDLE_OPEN = `HANDLE_OPEN`

export const HANDLE_CLOSE = `HANDLE_CLOSE`

export function success(message) {
    return {type: HANDLE_OPEN, variant: 'success',message}
}
export function error(message) {
    return {type: HANDLE_OPEN, variant: 'error',message}
}
const initialState = {
    message: {
        open: false,
        variant: '',
        message: '',
        time: 2000
    }  
}
export default createReducer(initialState, {
    [HANDLE_OPEN]: (state, {variant, message, time = 2000}) => {
        return {...state,message: {...state.message,open: true,variant,message,time}}
    },
    [HANDLE_CLOSE]: (state) => {
        return {...state,message: {...state.message,open:false,variant: state.message.variant}}
    }
})


// WEBPACK FOOTER //
// ./src/uis/tip/reduces.js